import styled from "styled-components";

export const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    margin: 0;

    max-height: 254px;
    overflow-y: auto;
`;
